import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { SigninComponent } from './core/signin/signin.component';
import { PageNotFoundComponent } from './core/page-not-found/page-not-found.component';
import { AuthGuard } from './auth/services/auth.guard';
import { Role } from './auth/models/user';
import { AccesDeniedComponent } from './core/acces-denied/acces-denied.component';
import { ForgotPasswordComponent } from './core/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './core/reset-password/reset-password.component';


const routes: Routes = [
  { path: '',redirectTo:'login',pathMatch:'full'},
  { path:'login', component:SigninComponent },
  { path: 'forgot-password', component:ForgotPasswordComponent},
  { path: 'reset-password', component:ResetPasswordComponent},
  { 
    path: 'organization',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/organization-admin/organization-admin.module').then(m =>m.OrganizationAdminModule),
    data: {
      allowedRoles: [Role.SuperAdmin],
      breadcrumb: 'Organization',
    }
  },
  {
    path: 'superadmin',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/super-admin/super-admin.module').then(m=>m.SuperAdminModule),
    data: {
      allowedRoles: [Role.SuperAdmin],
      breadcrumb: 'Superadmin',
    }
  },
  {
    path: 'users',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/users/users.module').then(m =>m.UsersModule),
    data: {
      allowedRoles: [Role.SuperAdmin, Role.OrganizationAdmin],
      breadcrumb: 'Users',
    }
  },
  {
    path: 'attendance',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/attendance/attendances.module').then(m => m.AttendancesModule),
    data: {
      breadcrumb: 'attendance',
    }
  },
  {
    path: 'leaves',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/leaves/leaves.module').then(m => m.LeavesModule),
    data: {
      breadcrumb: 'Leaves',
    }
  },
  {
    path: 'wfh',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/wfh/wfh.module').then(m => m.WfhModule),
    data: {
      breadcrumb: 'Wfh',
    }
  },
  {
    path: 'upload-files',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/upload-files/upload-files.module').then(m => m.UploadFilesModule),
    data: {
      breadcrumb: 'Upload Files',
    }
  },
  {
    path: 'holidays',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/holidays/holidays.module').then( m => m.HolidaysModule),
    data: {
      allowedRoles: [Role.SuperAdmin, Role.OrganizationAdmin],
      breadcrumb: 'Holidays',
    }
  },
  {
    path: 'shifts',
    canActivate: [ AuthGuard ],
    loadChildren: ()=>import('./modules/shifts/shifts.module').then(m => m.ShiftsModule),
    data: {
      allowedRoles: [Role.SuperAdmin, Role.OrganizationAdmin],
      breadcrumb: 'Shifts',
    }
  },
  {
    path: 'dashboard',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/dashboard/dashboard.module').then( m => m.DashboardModule),
    data: {
      breadcrumb: 'Dashboard',
    }
  },
  {
    path: 'leave-type',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/leave-type/leave-type.module').then( m => m.LeaveTypeModule),
    data: {
      allowedRoles: [Role.SuperAdmin, Role.OrganizationAdmin],
      breadcrumb: 'leave-type',
    }
  },
  {
    path: 'org-leaves',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/org-leave/org-leave.module').then( m => m.OrgLeaveModule),
    data: {
      allowedRoles: [Role.SuperAdmin, Role.OrganizationAdmin],
      breadcrumb: 'leave-type',
    }
  },
  {
    path: 'screenshot',
    canActivate: [ AuthGuard],
    loadChildren: () => import('./modules/screenshot/screenshot.module').then( m => m.ScreenshotModule),
    data: {
      allowedRoles: [ Role.SuperAdmin,Role.OrganizationAdmin, Role.UserReport],
      breadcrumb: 'screenshot'
    }
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/settings/settings.module').then( m => m.SettingsModule),
    data:{
      breadcrumb: 'settings'
    }
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
    data: {
      allowedRoles: [Role.SuperAdmin, Role.OrganizationAdmin, Role.UserReport],
      breadcrumb: 'reports'
    }
  },
  {
    path: 'access-denied', component: AccesDeniedComponent
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
